module.exports = __webpack_public_path__ + "static/media/skype-skype-icon-svgrepo-com.215d60d5.svg";